// AUTOGENERATED
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const restaurantIdIsSymbol = {reflectSymbol: () => "restaurantId"};
const GetPaymentChannelsRequestIsSymbol = {reflectSymbol: () => "GetPaymentChannelsRequest"};
const GetPaymentChannelsRequest = x => x;
const toFillFormTypeGetPaymentC = {fillFormDataType: v => "unknown"};
const rPCSitesGetPaymentChannel = {};
const rPCMethodNameGetPaymentCh = {rpcMethodName: v => "GetPaymentChannelsRequest"};
const newtypeGetPaymentChannels = {Coercible0: () => {}};
const hasFieldGetPaymentChannel = dictHasField => dictHasField;
const eqGetPaymentChannelsReque = {eq: x => y => x.restaurantId === y.restaurantId};
const genericGetPaymentChannelsRequest = {to: x => x, from: x => x};
const showGetPaymentChannelsRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{ restaurantId: " + Data$dShow.showIntImpl(v.restaurantId) + " }"]})(GetPaymentChannelsRequestIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeGetPaymentChannelsRequest = /* #__PURE__ */ (() => (
  {unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(restaurantIdIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))}
))();
const encodeGetPaymentChannelsRequest = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericGetPaymentChannelsRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(GetPaymentChannelsRequestIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(restaurantIdIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeGetPaymentChannelsRequest = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericGetPaymentChannelsRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(GetPaymentChannelsRequestIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(restaurantIdIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  GetPaymentChannelsRequest,
  GetPaymentChannelsRequestIsSymbol,
  decodeGetPaymentChannelsRequest,
  encodeGetPaymentChannelsRequest,
  eqGetPaymentChannelsReque,
  genericGetPaymentChannelsRequest,
  hasFieldGetPaymentChannel,
  newtypeGetPaymentChannels,
  rPCMethodNameGetPaymentCh,
  rPCSitesGetPaymentChannel,
  restaurantIdIsSymbol,
  showGetPaymentChannelsRequest,
  toFillFormTypeGetPaymentC,
  unscrambleDecodeGetPaymentChannelsRequest
};
